import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {useNavigate} from "react-router-dom";
import {FaMapMarkedAlt} from "react-icons/fa";
import {BsChevronCompactLeft} from "react-icons/bs";
import {GiReturnArrow, GiTwoCoins} from "react-icons/gi";
import {PiMagnifyingGlassFill} from "react-icons/pi";
import {TbBrandMyOppo} from "react-icons/tb";


export default function Reports() {
    const navigate = useNavigate();
    React.useEffect(() => {

        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)

    }, []);
   return (
        <React.Fragment>

            <Header title='گزارش ها' hasBack={false} />

            <main className="container-fluid mt-3 pt-5">


                <div className="container-fluid profile-list-items">

                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/sales-report')} >

                        <div className="col-1">
                            <GiTwoCoins  className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                          نمودار فروش
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>

                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/vendors-report')} >

                        <div className="col-1">
                            <GiReturnArrow   className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                          گزارش عملکرد نمایندگان
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>

             {/*       <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/return-report')} >

                        <div className="col-1">
                            <TbReplaceFilled    className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                          گزارش باتری های جایگزین شده
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>

                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/return-report')} >

                        <div className="col-1">
                            <FaStore    className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                          گزارش وضعیت یک نماینده
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>*/}

                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/brands-report')} >

                        <div className="col-1">
                            <TbBrandMyOppo    className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                          گزارش بر اساس برندها
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>

                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/regions-report')} >

                        <div className="col-1">
                            <FaMapMarkedAlt    className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                          گزارش عملکرد منطقه ای
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>



                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/search-product')} >

                        <div className="col-1">
                            <PiMagnifyingGlassFill    className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                         مشاهده اطلاعات یک باتری
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>
                </div>

            </main>
            <Navbar  />
        </React.Fragment>
    );

}

